define('common/slickSlider',[
],
    function () {

        function init(selector, options) {
            if (!options) options = { dots: true };
            $(selector).each(function (index, element) {
                if ($(element).hasClass("slick-initialized")) {
                    $(element).slick("unslick");
                }
                $(element).slick(options);
            });
        }

        function destroy(selector) {
            $(selector).each(function (index, element) {
                if ($(element).hasClass("slick-initialized")) {
                    $(element).slick("unslick");
                }
            });
        }

        return {
            init: init,
            destroy: destroy
        };
    });

